import { getAPI, type UserAPI } from '@sydle/ui-api';
import { Provider, getConfig, setAction } from '@sydle/ui-utils';
import { fetchGetPost } from '../actions/fetch-get-post';
import { getListingPageMetadata } from '../actions/get-listing-page-metadata';
import { createBlogAPI } from '../api/blog-api';
import { type BlogConfig } from '../types/blog';
import { BlogRoutes } from '../utils/router-utils';
import { addUtmTagsToExternalLink } from '../utils/utils';
export default async (): Promise<void> => {
  let languagePath: string | undefined | null = window.location.pathname
    .split('/')
    .find((path) => path.match(/^([a-z]{2}(-[a-z]{2})?)$/) || path === 'blog');
  if (languagePath === 'blog') languagePath = null;
  const language =
    getConfig<BlogConfig>('sydle-ui-blog')?.configByLanguage?.find((config) => config.urlPath === languagePath)
      ?.language.code ?? 'en';

  getAPI<UserAPI>('userAPI')?.setCurrentLanguage(language);
  createBlogAPI();
  const bodyProvider = new Provider(document.documentElement);

  bodyProvider.provides('postBody', null);
  bodyProvider.provides('getPostsParams', null);

  setAction(BlogRoutes.POST, fetchGetPost);
  setAction(BlogRoutes.DRAFT, fetchGetPost);
  setAction(BlogRoutes.SEARCH, getListingPageMetadata);
  setAction(BlogRoutes.CATEGORY, getListingPageMetadata);
  setAction(BlogRoutes.HOME, getListingPageMetadata);
  setAction(BlogRoutes.TAG, getListingPageMetadata);

  document.documentElement.addEventListener('click', addUtmTagsToExternalLink);
};
